"use client";

import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import styles from "./fade-overlay.module.css";

function useScrollEdges() {
  const [top, setTop] = useState(true);
  const [bottom, setBottom] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setTop(window.scrollY < 10);
      setBottom(
        window.innerHeight + window.scrollY >=
          document.documentElement.scrollHeight - 10
      );
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return { top, bottom };
}

function Fade({
  side,
  className,
  ...motionProps
}: {
  side: "top" | "bottom";
  className?: string;
} & React.ComponentProps<typeof motion.div>) {
  return (
    <motion.div
      aria-hidden
      className={`${styles.fade} ${className ?? ""}`}
      data-side={side}
      style={
        {
          "--stop": "25%",
          "--blur": "4px",
          "--background": "var(--sand-1)",
        } as React.CSSProperties
      }
      {...motionProps}
    />
  );
}

export function FadeOverlay() {
  const { top: topEdgeTouched, bottom: bottomEdgeTouched } = useScrollEdges();

  return (
    <div className="fixed top-0 left-0 pointer-events-none h-screen w-screen z-[10001]">
      <AnimatePresence>
        {!topEdgeTouched && (
          <Fade
            key="top"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            side="top"
            className="absolute top-0 left-0 w-full h-[100px] sm:h-[150px]"
          />
        )}
      </AnimatePresence>
      <AnimatePresence>
        {!bottomEdgeTouched && (
          <Fade
            key="bottom"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            side="bottom"
            className="absolute bottom-0 left-0 w-full hidden sm:inline h-[150px]"
          />
        )}
      </AnimatePresence>
    </div>
  );
}
